import { Search } from "~/Search";

import {
  Exemption,
  Exemption as Exemption_,
  Exemptions as Exemptions_,
} from "./Exemption";

import { Timer as Timer_, Timers, Timers as Timers_ } from "./Timers";
import { Type, Type as Type_, Types as Types_ } from "./Type";

export type HoursOfService = {
  readonly hoursOfService: Partial<Type & Exemption & Timers>;
};

export namespace HoursOfService {
  export import Type = Type_;
  export import Types = Types_;
  export import Exemption = Exemption_;
  export import Exemptions = Exemptions_;
  export import Timer = Timer_;
  export import Timers = Timers_;

  export const toSearch: Search.From<HoursOfService> = ({ hoursOfService }) =>
    Search.join(
      hoursOfService.type
        ? Type.toSearch({ type: hoursOfService.type })
        : Search.empty(),
      hoursOfService.exemption
        ? Exemption.toSearch({ exemption: hoursOfService.exemption })
        : Search.empty(),
      hoursOfService.timers
        ? Timers.toSearch({ timers: hoursOfService.timers })
        : Search.empty()
    );
}
